import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  redirectButton: {
    margin: `${theme.spacing(3)}px auto 0`,
    display: 'block',
    width: 'fit-content',
  },
}));
